import React, { useContext, useEffect, useState } from 'react';
import { Button, Modal } from '@material-ui/core';

import { logisticsApi } from 'api/logistics';
import { UserContext } from 'contexts/UserContext';
import { DataTable, Notifications } from 'shared';

function ResetModal({ closeModal, hub, lineHaulID }) {
    return (
        <div>
            <Modal open onClose={closeModal}>
                <div>
                    <div
                        style={{
                            outline: 0,
                            backgroundColor: 'white',
                            width: '400px',
                            margin: '10% auto',
                            padding: '10px',
                        }}
                    >
                        You are about to revert {hub} ID {lineHaulID} with Delivery Day to unplanned status - Do you
                        wish to proceed?
                        <div>
                            <Button
                                onClick={async () => {
                                    const res = await logisticsApi.resetLineHaulRouting(lineHaulID);
                                    if (res.status == false) {
                                        closeModal({ text: 'Error reverting line haul: '.res.msg, level: 'error' });
                                        return;
                                    }
                                    closeModal({ text: 'Successfully reverted line haul', level: 'success' });
                                }}
                            >
                                Confirm
                            </Button>
                            <Button onClick={() => closeModal({})}>Cancel</Button>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
}
function ResetLineHaulRouting() {
    const user = useContext(UserContext);
    const [notification, setNotification] = useState({ text: null, level: null });
    const [showResetModal, setShowResetModal] = useState(false);
    const [modalParams, setModalParams] = useState({});
    const [rows, setRows] = useState([]);

    const getRecentLineHaulShippingDays = async () => {
        const response = await logisticsApi.getRecentLineHaulShippingDays(user.getFacilityID());

        if (response.status === false) {
            setNotification({ text: 'Error getting recent shipping day: '.response.msg, level: 'error' });
            return;
        }

        setRows(response.data.rows);
    };

    useEffect(() => {
        getRecentLineHaulShippingDays();
    }, []);

    const columns = [
        { accessor: 'lineHaulID', Header: 'ID' },
        { accessor: 'hub', Header: 'Hub' },
        { accessor: 'preferredDay', Header: 'Preferred Day' },
        {
            accessor: 'reset',
            Header: 'Reset',
            Cell: ({ row }) => (
                <Button
                    onClick={() => {
                        setModalParams({
                            lineHaulID: row.original.lineHaulID,
                            preferredDay: row.original.preferredDay,
                            hub: row.original.hub,
                        });
                        setShowResetModal(true);
                    }}
                >
                    Reset
                </Button>
            ),
        },
    ];

    return (
        <div>
            <Notifications options={notification} />
            {showResetModal && (
                <ResetModal
                    lineHaulID={modalParams.lineHaulID}
                    hub={modalParams.hub}
                    closeModal={(notificationPassback) => {
                        setModalParams({});
                        setShowResetModal(false);
                        setNotification(notificationPassback);
                    }}
                />
            )}
            <DataTable columns={columns} data={rows} />
        </div>
    );
}

export { ResetLineHaulRouting };
